import LoginPage from "~/pages/login/LoginPage.vue";
import MTLoginPage from "~/pages/admin/login/MTLoginPage.vue";
import PasswordReissueEntryPage from "~/pages/passwordReissue/PasswordReissueEntryPage.vue";
import PasswordReissueCheckPage from "~/pages/passwordReissue/PasswordReissueCheckPage.vue";
import PasswordReissueCompletePage from "~/pages/passwordReissue/PasswordReissueCompletePage.vue";
const routes = [
    {
        path: "/",
        name: "index",
        component: () => import("layouts/MainLayout.vue"),
        children: []
    },
    // 初期画面（入居者）
    {
        name: "login",
        path: "/login",
        component: LoginPage
    },
    // タイムアウト（入居者）
    {
        name: "timeout",
        path: "/login",
        component: LoginPage
    },
    // 初期画面（管理者）
    {
        name: "mt-login",
        path: "/mt/login",
        component: MTLoginPage
    },
    // タイムアウト（管理者）
    {
        name: "mt-timeout",
        path: "/mt/login",
        component: MTLoginPage
    },
    // パスワード再発行（入居者）
    {
        path: "/password-reissue",
        component: () => import("layouts/NoAuthLayout.vue"),
        children: [
            { name: "password-reissue-entry", path: "entry", component: PasswordReissueEntryPage },
            { name: "password-reissue-check", path: "check", component: PasswordReissueCheckPage },
            { name: "password-reissue-complete", path: "complete", component: PasswordReissueCompletePage }
        ]
    },
    // 404エラー
    {
        name: "404",
        path: "/:catchAll(.*)*",
        component: () => import("pages/Error404.vue")
    },
];
export default routes;
